import React, { useState } from 'react';
import { Modal } from '../UI/Modal';
import { Button } from '../UI/Button';
import type { AgentChannel } from '../../types/agentPlatform';

const CHANNEL_OPTIONS: { value: AgentChannel; label: string }[] = [
  { value: 'Web', label: 'Web' },
  { value: 'Api', label: 'API' },
  { value: 'BTalk', label: 'BTalk' },
  { value: 'Slack', label: 'Slack' },
  { value: 'Teams', label: 'Teams' },
  { value: 'WhatsApp', label: 'WhatsApp' },
];

type Props = {
  isOpen: boolean;
  agentName: string;
  onConfirm: (channels: AgentChannel[], changeNotes: string) => void;
  onCancel: () => void;
  loading?: boolean;
};

export const AgentPublishModal: React.FC<Props> = ({
  isOpen,
  agentName,
  onConfirm,
  onCancel,
  loading = false,
}) => {
  const [channels, setChannels] = useState<AgentChannel[]>(['Web', 'Api']);
  const [changeNotes, setChangeNotes] = useState('');

  const toggle = (ch: AgentChannel) => {
    setChannels(prev => (prev.includes(ch) ? prev.filter(c => c !== ch) : [...prev, ch]));
  };

  return (
    <Modal isOpen={isOpen} title="Publicar agente" onClose={onCancel}>
      <p className="text-sm text-gray-600 mb-4">
        Publicar <strong>{agentName}</strong> cria uma nova versão ativa. Canais são registrados na
        versão (roteamento na execução virá em fase posterior).
      </p>

      <fieldset className="mb-4">
        <legend className="text-sm font-medium text-gray-700 mb-2">Canais</legend>
        <div className="flex flex-wrap gap-3">
          {CHANNEL_OPTIONS.map(opt => (
            <label key={opt.value} className="flex items-center gap-2 text-sm">
              <input
                type="checkbox"
                checked={channels.includes(opt.value)}
                onChange={() => toggle(opt.value)}
              />
              {opt.label}
            </label>
          ))}
        </div>
      </fieldset>

      <div className="mb-6">
        <label className="block text-sm font-medium text-gray-700 mb-1">Notas da versão</label>
        <textarea
          className="w-full border rounded-md px-3 py-2 text-sm"
          rows={2}
          value={changeNotes}
          onChange={e => setChangeNotes(e.target.value)}
          placeholder="Opcional"
        />
      </div>

      <div className="flex justify-end gap-2">
        <Button variant="secondary" onClick={onCancel} disabled={loading}>
          Cancelar
        </Button>
        <Button onClick={() => onConfirm(channels, changeNotes)} disabled={loading}>
          {loading ? 'Publicando…' : 'Publicar'}
        </Button>
      </div>
    </Modal>
  );
};
